import moment from 'moment';
import './dayDiff';

moment.fn.isBeforeToday = function isBeforeToday() {
    return this.dayDiff(moment()) < 0;
};
